export default __webpack_public_path__ + "static/DisplayHDR-1000-7fdfc4fa2620e50e9ef1149a8d73f7c8.png";